// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const examRoutes = {
	participantDevice: "participant-device",
	participantDevice_studentInside: "student-inside",
	participantDevice_studentOutside: "student-outside",
	participantDevice_examiner: "examiner",
	participantDevice_sp: "sp",
	confirmationApp: "confirmation-app",
};

export const peerPracticeRoutes = {
	peerPracticeStudentApp: "peer-practice-student-app",
};

/**
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
export const routes = {
	routes: {
		login: "login",
		sessionDashboard: "session-dashboard",
		eventDashboard: "event-dashboard",
		testing: "testing",
		error: "error",
		simrecorder: "simrecorder",
		debriefing: "debriefing",
		deviceRegistration: "device-registration",
		liveView: "live-view",
		simPlayer: "sim-player",
		simDebriefingPlayer: "sim-debriefing-player",
		sessionSelection: "session-selection",
		recordingSelection: "recording-selection",
		autoLogin: "auto-login",
		healthMonitor: "health-monitor",
		display: "display",

		webManager: "web-manager",

		proSessionSelection: "pro-session-selection",
		playerSelection: "player-selection",

		eventDetail: "event-detail",
		roomPlanner: "room-planner",
		stageDesigner: "stage-designer",
		presentation: "presentation",
		participationView: "participation-view",
		cameraViewer: "camera-viewer",
		roomCast: "live-view",
		syncRecordings: "sync-recordings",

		...examRoutes,
		...peerPracticeRoutes,
		groupManager: "group-manager",
		masterOfCeremonyApp: "master-of-ceremony-app",
	},
};
